import { Card } from '../../design-system';
import React, { useContext } from 'react';
import { useEffectOnce } from 'react-use';
import { Session } from '../../contexts/sessionContext';
import { useData } from '../../helpers/data-loader';
import { addStoText, errorMsg } from '../../helpers/utils';

const DeadlineCounts = () => {
  const {
    state: { user },
  } = useContext(Session);
  const [counts, fetch] = useData('deadline/counts', {
    errorMsg: errorMsg('deadlines'),
  });

  useEffectOnce(() => {
    fetch();
  });

  return (
    <Card p={2}>
      <Card.Body>
        <p className="font-bold text-lg mb-1">Due Today</p>
        <p className="text-sm text-gray-500 mb-2">
          {user.timezone || 'America/Chicago'}
        </p>
        <dl className="divide-y divide-gray-100 border-theme rounded overflow-hidden">
          <div className="bg-gray-50 flex justify-between p-2">
            <dt className="text-md font-medium leading-6 text-gray-900">
              Projects
            </dt>
            <a
              id="projects-today"
              href="/projects?deadline=1&active=active"
              className="mt-1 text-md leading-6 text-blue-600 underline sm:col-span-2 sm:mt-0"
            >
              {counts.projects}
            </a>
          </div>
          <div className="flex justify-between p-2">
            <dt className="text-md font-medium leading-6 text-gray-900">
              Deadlines
            </dt>
            <a
              id="deadlines-today"
              href="/deadlines?deadline=1&active=active"
              className="mt-1 text-md leading-6 text-blue-600 underline sm:col-span-2 sm:mt-0"
            >
              {counts.today}
            </a>
          </div>
        </dl>
        <p className="font-bold text-lg mb-2 mt-4">Upcoming</p>
        <dl className="divide-y divide-gray-100 border-theme rounded-md overflow-hidden">
          <div className="bg-gray-50 flex justify-between p-2">
            <dt className="text-md font-medium leading-6 text-gray-900">
              Deadline{addStoText(counts.sevenDays)} in 7 Days
            </dt>
            <a
              id="deadlines-7"
              href="/deadlines?deadline=7&active=active"
              className="mt-1 text-md leading-6 text-blue-600 underline sm:col-span-2 sm:mt-0"
            >
              {counts.sevenDays}
            </a>
          </div>
          <div className="bg-gray-05 flex justify-between p-2">
            <dt className="text-md font-medium leading-6 text-gray-900">
              Deadline{addStoText(counts.thirtyDays)} in 30 Days
            </dt>
            <a
              id="deadlines-30"
              href="/deadlines?deadline=30&active=active"
              className="mt-1 text-md leading-6 text-blue-600 underline sm:col-span-2 sm:mt-0"
            >
              {counts.thirtyDays}
            </a>
          </div>
          <div className="bg-gray-50 flex justify-between p-2">
            <dt className="text-md font-medium leading-6 text-gray-900">
              Deadline{addStoText(counts.sixityDays)} in 60 Days
            </dt>
            <a
              id="deadlines-60"
              href="/deadlines?deadline=60&active=active"
              className="mt-1 text-md leading-6 text-blue-600 underline sm:col-span-2 sm:mt-0"
            >
              {counts.sixityDays}
            </a>
          </div>
          <div className="bg-gray-05 flex justify-between p-2">
            <dt className="text-md font-medium leading-6 text-gray-900">
              Deadline{addStoText(counts.ninetyDays)} in 90 Days
            </dt>
            <a
              id="deadlines-90"
              href="/deadlines?deadline=90&active=active"
              className="mt-1 text-md leading-6 text-blue-600 underline sm:col-span-2 sm:mt-0"
            >
              {counts.ninetyDays}
            </a>
          </div>
        </dl>
      </Card.Body>
    </Card>
  );
};

export default DeadlineCounts;
